import { useState } from "react";
import {
  DetailModule,
  DetailContentWrapper,
  DetailGrid,
  DetailContainer,
  Item,
  ItemTopWrapper,
  UlWrapper,
  Select,
  TimeContainer,
  TimeInputContianer,
  TimeTableContainer,
  TimeInputWrapper,
  LabelWrapper,
  FieldWrapper,
  Block,
  Expensecontainer,
  ExpenseHeader,
  Icon,
  CommentContainer,
  CommentPost,
  CommentBody,
  CommentHeader,
} from "./detailStyle";
import styled from "styled-components";
import {
  TelephoneFill,
  PersonFill,
  ListUl,
  ExclamationCircleFill,
  BookFill,
} from "@styled-icons/bootstrap";
import { CalendarDateFill } from "@styled-icons/bootstrap/";
import { Comments } from "@styled-icons/fa-solid/Comments";
import { Email } from "@styled-icons/evaicons-solid/Email/";
import { Profile } from "@styled-icons/icomoon/Profile/";
import { DollarBill } from "@styled-icons/foundation/DollarBill";
import { Button, Header, Heading, MainContainer } from "../../globalStyles";
import DetailTable from "../../components/detailTable/DetailTable";
import {
  expenseColumns,
  expenseRows,
  timeColumns,
  timeRows,
} from "../../tableSource";
import DatePicker1 from "../../components/datePicker/DatePicker";
import TimePicker from "../../components/timePicker/TimePicker";
import Collapse from "@kunukn/react-collapse";
const ListSm = styled(ListUl)`
  width: 22px;
  margin-right:5px;
  color: #614e20;
`;
const Comments1 = styled(Comments)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const Person = styled(PersonFill)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const Phone = styled(TelephoneFill)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const ExclamationCircl = styled(ExclamationCircleFill)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const CalendarDateFill1 = styled(CalendarDateFill)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const BookFil = styled(BookFill)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const Email1 = styled(Email)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const Profile1 = styled(Profile)`
width: 22px;
margin-right:5px;
  color: #614e20;
`;
const DollarBillE = styled(DollarBill)`
  width: 90%;
  color: #614e20ff;
`;
const collapseStyles = { transitionDuration: "270ms" };

const Detail = () => {
  const [selected, setSelected] = useState(null);
  const [isOpen2, setOpen2] = useState(true);
  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };
  const onInit = (state) => {
    // let collapse = "isOpen" + index;
    setOpen2(false);
    // this.setState(prevState => ({ [collapse]: !prevState[collapse] }));
  };
  return (
    <>
      <MainContainer>
        <DetailModule>
          <Header>
            <DetailContentWrapper>
              <h1>ASSIGNMENT NO. A190398 DETAILS</h1>
            </DetailContentWrapper>
          </Header>

          <DetailGrid>
            <DetailContainer>
              <Item>
                <ItemTopWrapper>
                  <h1>Member Details</h1>
                </ItemTopWrapper>
              </Item>
              <UlWrapper>
                <ul>
                  <li>
                    <Person />
                    Member Name: AV 100
                  </li>
                  <li>
                    <Phone /> Member Number: M190047
                  </li>
                </ul>
              </UlWrapper>
            </DetailContainer>
            <DetailContainer>
              <Item>
                <ItemTopWrapper>
                  <h1>Assignment Details</h1>
                </ItemTopWrapper>
              </Item>
              <UlWrapper>
                <ul>
                  <li>
                    <ListSm /> Assignment No.: A190398 AV 100
                  </li>
                  <li>
                    <ExclamationCircl /> Status: Verified
                  </li>
                  <li>
                    <BookFil /> Assignment Title:AV-100 June 16-30
                  </li>
                  <li>
                    <CalendarDateFill1 /> Request Date: 06-15-2020
                  </li>
                  <li>
                    <Person /> Created By: Kevin Borzenski
                  </li>
                </ul>
              </UlWrapper>
            </DetailContainer>
          </DetailGrid>

          <Header>
            <DetailContentWrapper>
              {/* <h1 onClick={() => toggle(1)}>ASSIGNMENT NO. A190398 DETAILS</h1> */}
              <h1 onClick={() => setOpen2((state) => !state)}>
                ASSIGNMENT NO. A190398 DETAILS
              </h1>
              <Select>
                <option value="" hidden selected>
                  Please Select task state
                </option>
                <option value="1">In Progress</option>
                <option value="2">Done</option>
              </Select>
            </DetailContentWrapper>
          </Header>
          <Collapse
            isOpen={isOpen2}
            className={"app__collapse app__collapse--gradient "}
            transition="height 800ms cubic-bezier(0.4, 0, 0.1, 1)"
            aria-hidden={isOpen2 ? "false" : "true"}
            elementType="article"
            onInit={onInit}
          >
            <DetailGrid>
              <DetailContainer>
                <Item>
                  <ItemTopWrapper>
                    <h1>Client Details</h1>
                  </ItemTopWrapper>
                </Item>
                <UlWrapper>
                  <ul>
                    <li>
                      <Person />
                      No. of Passengers: 0
                    </li>
                  </ul>
                </UlWrapper>
                <Item>
                  <ItemTopWrapper>
                    <h1>ATF Details</h1>
                  </ItemTopWrapper>
                </Item>
                <UlWrapper>
                  <ul>
                    <li>
                      <Person />
                      Name: Josh Brannon
                    </li>
                    <li>
                      <Phone /> Member Number: M190047
                    </li>
                    <li>
                      <Email1 /> Email: josh@avariworld.com
                    </li>
                    <li>
                      <Profile1 /> ATF Profile
                    </li>
                  </ul>
                </UlWrapper>
              </DetailContainer>
              <DetailContainer>
                <Item>
                  <ItemTopWrapper>
                    <h1>Assignment Details</h1>
                  </ItemTopWrapper>
                </Item>
                <UlWrapper>
                  <ul>
                    <li>
                      <ListSm /> Assignment No.: A190398 AV 100
                    </li>
                    <li>
                      <ExclamationCircl /> Status: Verified
                    </li>
                    <li>
                      <BookFil /> Assignment Title:AV-100 June 16-30
                    </li>
                    <li>
                      <CalendarDateFill1 /> Request Date: 06-15-2020
                    </li>
                    <li>
                      <Person /> Created By: Kevin Borzenski
                    </li>
                  </ul>
                </UlWrapper>
              </DetailContainer>

              <TimeContainer>
                <TimeInputContianer>
                  <form action="">
                    <TimeInputWrapper>
                      <p>Task Prep</p>
                      <Block>
                        <LabelWrapper>
                          <span>Start</span>
                          <span>End</span>
                        </LabelWrapper>

                        <FieldWrapper>
                          <DatePicker1 />
                          <DatePicker1 />
                          {/* <input type="text" /> */}
                        </FieldWrapper>

                        <FieldWrapper width="short">
                          <TimePicker />
                          <DatePicker1 />
                        </FieldWrapper>

                        <FieldWrapper variant="row">
                          <Button variant="small">Save</Button>
                          <Button variant="small">Delete</Button>
                        </FieldWrapper>
                      </Block>
                    </TimeInputWrapper>

                    <TimeInputWrapper>
                      <p>Task Prep</p>
                      <Block>
                        <LabelWrapper>
                          <span>Start</span>
                          <span>End</span>
                        </LabelWrapper>

                        <FieldWrapper>
                          <DatePicker1 />
                          <DatePicker1 />
                        </FieldWrapper>

                        <FieldWrapper width="short">
                          <TimePicker />
                          <DatePicker1 />
                        </FieldWrapper>

                        <FieldWrapper variant="row">
                          <Button variant="small">Save</Button>
                          <Button variant="small">Delete</Button>
                        </FieldWrapper>
                      </Block>
                    </TimeInputWrapper>
                    <TimeInputWrapper>
                      <p>Task Prep</p>
                      <Block>
                        <LabelWrapper>
                          <span>Start</span>
                          <span>End</span>
                        </LabelWrapper>
                        <FieldWrapper>
                          <DatePicker1 />
                          <DatePicker1 />
                        </FieldWrapper>

                        <FieldWrapper width="short">
                          <DatePicker1 />
                          <DatePicker1 />
                        </FieldWrapper>

                        <FieldWrapper variant="row">
                          <Button variant="small">Save</Button>
                          <Button variant="small">Delete</Button>
                        </FieldWrapper>
                      </Block>
                    </TimeInputWrapper>
                  </form>
                </TimeInputContianer>

                <TimeTableContainer>
                  <DetailTable rows={timeRows} columns={timeColumns} />
                </TimeTableContainer>
              </TimeContainer>

              <Expensecontainer>
                <ExpenseHeader>
                  <Heading>Task Expense</Heading>
                  <Icon>
                    <DollarBillE />
                  </Icon>
                </ExpenseHeader>

                <DetailTable rows={expenseRows} columns={expenseColumns} />
                {/* <CommentHeader> */}
                {/* <Item>
                    <ItemTopWrapper>
                      <h1>Comments</h1>
                    </ItemTopWrapper>
                  </Item>
                  <UlWrapper>
                    <ul>
                      <li>
                        <Comments1 />
                        Josh Brannon : 08-01-2022 12:09 AMdsf
                      </li>
                    </ul>
                  </UlWrapper>
                  <textarea id="w3review" name="w3review" rows="8">
                    At w3schools.com you will learn how to make a website. They
                    offer free tutorials in all web development technologies.
                  </textarea> */}
                {/* <Button variant="small">Save</Button> */}
                {/* </CommentHeader> */}
              </Expensecontainer>

              <CommentContainer>
                <CommentHeader>
                  <Heading>Comments</Heading>
                </CommentHeader>
                <CommentBody>
                  <textarea name="comment" id="comment"></textarea>
                </CommentBody>
                <CommentPost>
                  <Button>Post Comment</Button>
                </CommentPost>
              </CommentContainer>
            </DetailGrid>
          </Collapse>

          {/* {selected === 1 ? ( */}

          {/* ) : (
            ""
          )} */}

          <Header>
            <DetailContentWrapper>
              <h1>ASSIGNMENT NO. A190398 DETAILS</h1>
            </DetailContentWrapper>
          </Header>
        </DetailModule>
      </MainContainer>
    </>
  );
};

export default Detail;
